<template>
    <div class="content-wrapper">
        <div class="tabs-custom-group">
            <button :class="['tab-btn', activeTab === 'seo' ? 'tab-btn-active' : 'tab-btn-inactive']" @click="activeTab = 'seo'">SEO</button>
            <button class="tab-btn tab-btn-inactive" disabled>Formulário</button>
            <button class="tab-btn tab-btn-inactive" disabled>Analytics</button>
        </div>

        <div class="content-container">
            <div v-show="activeTab === 'seo'">
                <h2 class="seo-title mb-6">Configurações de SEO</h2>
                <div class="space-y-6">
                    <div>
                        <label class="label-title block mb-2">
                            Título da Página
                            <span class="text-red-500">*</span>
                        </label>
                        <input
                            type="text"
                            v-model="tituloLandingPage"
                            :class="getInputClasses('tituloLandingPage')"
                            placeholder="Título da Landing Page"
                            maxlength="60"
                            @blur="markFieldAsTouched('tituloLandingPage')"
                        />
                        <div class="flex justify-between mt-1">
                            <small v-if="shouldShowValidationError('tituloLandingPage')" class="text-red-500 text-sm">
                                {{ validation.tituloLandingPage.message }}
                            </small>
                        </div>
                    </div>

                    <div>
                        <label class="label-title block mb-2">Descrição</label>
                        <textarea
                            v-model="descricao"
                            rows="4"
                            :class="getTextareaClasses('descricao')"
                            placeholder="Descrição da sua Landing Page"
                            @blur="markFieldAsTouched('descricao')"
                        />
                        <div class="flex justify-between mt-1">
                            <span class="desc-tip">
                                {{ shouldShowValidationError('descricao') ? validation.descricao.message : 'Recomendado: até 160 caracteres' }}
                            </span>
                        </div>
                    </div>

                    <div>
                        <label class="label-title block mb-2">Palavras-chave</label>
                        <Chips v-model="palavrasChave" addOnBlur separator="," @blur="markFieldAsTouched('palavrasChave')" class="palavras-chave" />
                    </div>

                    <div>
                        <label class="label-title block mb-2">Imagem de Compartilhamento (URL)</label>
                        <input
                            type="url"
                            v-model="imagemCompartilhamento"
                            :class="getInputClasses('imagemCompartilhamento')"
                            placeholder="https://exemplo.com/imagem.jpg"
                            @blur="markFieldAsTouched('imagemCompartilhamento')"
                        />
                        <div class="mt-1">
                            <small v-if="shouldShowValidationError('imagemCompartilhamento')" class="text-red-500 text-sm block">
                                {{ validation.imagemCompartilhamento.message }}
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useConfigLandingPage } from '@/composables/useConfigLandingPage';

const activeTab = ref('seo');

const {
    tituloLandingPage,
    descricao,
    palavrasChave,
    imagemCompartilhamento,
    validation,
    markFieldAsTouched,
    shouldShowValidationError,
    getInputClasses,
    getTextareaClasses,
} = useConfigLandingPage();
</script>

<style scoped>
.content-wrapper {
    flex-grow: 1;
}

.content-container {
    padding: 12px;
}

.transition-colors {
    transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

input,
textarea {
    font-size: 1.18rem;
    padding: 20px 20px;
    border: 1.5px solid #d1d5db;
    border-radius: 6px;
    color: #222;
    background: #fff;
    font-family: inherit;
    margin-bottom: 0.5rem;
}

input::placeholder,
textarea::placeholder {
    color: #888;
    font-size: 1.08rem;
    opacity: 1;
}

label,
.label-title {
    font-size: 1.25rem;
    font-weight: 700;
    color: #222;
    margin-bottom: 0.35rem;
    display: block;
}

.desc-tip {
    font-size: 1.08rem;
    color: #666 !important;
    font-weight: 500;
}

.space-y-6 > * + * {
    margin-top: 2.2rem !important;
}

input:focus,
textarea:focus {
    box-shadow: 0 0 0 2px #0f97c733;
    border-color: #0f97c7;
}

.text-xs {
    font-size: 1rem;
    color: #666 !important;
}

.text-lg {
    font-size: 1.25rem;
    font-weight: 700;
    color: #222;
}

.tabs-custom-group {
    padding: 0 12px;
    display: flex;
    background: #fff;
    width: fit-content;
    margin-top: 32px;
    margin-bottom: 24px;
    overflow: hidden;
}

.tab-btn {
    padding: 14px 18px;
    font-size: 14px;
    font-weight: 500;
    border: none;
    outline: none;
    background: transparent;
    color: #0f97c7;
    transition: background 0.2s, color 0.2s;
    cursor: pointer;
    border-radius: 0;
    border: 1px solid #0f97c7;
    min-width: 70px;
}

.tab-btn:first-child {
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
}

.tab-btn:last-child {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.tab-btn-active {
    background: #0f97c7;
    color: #fff;
}

.tab-btn-inactive:disabled {
    color: #0f97c7;
    opacity: 0.5;
    background: #fff;
    cursor: not-allowed;
}

.tab-btn:not(:disabled):hover {
    background: #e3f2fd;
}

.tab-btn + .tab-btn {
    border-left: none !important;
}

.font-mono {
    font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
}

.seo-title {
    font-size: 1.5rem;
    font-weight: 800;
    color: #222;
    line-height: 1.1;
}

.border-red-500 {
    border-color: #ef4444 !important;
}

.border-orange-400 {
    border-color: #fb923c !important;
}

.focus\:ring-red-500:focus {
    box-shadow: 0 0 0 2px rgba(239, 68, 68, 0.2) !important;
}

.focus\:ring-orange-400:focus {
    box-shadow: 0 0 0 2px rgba(251, 146, 60, 0.2) !important;
}

.focus\:border-red-500:focus {
    border-color: #ef4444 !important;
}

.focus\:border-orange-400:focus {
    border-color: #fb923c !important;
}

.text-red-500 {
    color: #ef4444 !important;
}

.text-orange-500 {
    color: #f97316 !important;
}

.text-green-500 {
    color: #22c55e !important;
}

.text-green-700 {
    color: #15803d !important;
}

.text-red-600 {
    color: #dc2626 !important;
}

.text-red-700 {
    color: #b91c1c !important;
}

.bg-red-50 {
    background-color: #fef2f2;
}

.bg-green-50 {
    background-color: #f0fdf4;
}

.border-red-200 {
    border-color: #fecaca;
}

.border-green-200 {
    border-color: #bbf7d0;
}

.p-chips {
    width: 100% !important;
}
</style>

<style>
.palavras-chave ul {
    width: 100%;
}
</style>
